import { makeStyles } from "@material-ui/core/styles";

/**
 * Shared message container styling hook for FetchError, NoResults, and FetchLoader components.
 * Provides common styles for centered message containers with consistent spacing.
 *
 * @returns {Object} Object containing Material-UI classes
 */
const useMessageContainerStyles = makeStyles(theme => ({
  actionContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    ...theme.typography.body1,
  },
}));

export default useMessageContainerStyles;
